<template>
  <div>
    <v-row>
      <v-col cols="12" class="py-1">
        <v-toolbar color="transparent" flat>
          <v-toolbar-title class="headline-header text-h6 px-0">
            {{ title }}
          </v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-divider class="pb-2 divider-header"/>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-btn v-if="routeTipo === 'bairro'" @click="openRelatorioBairro"
                 depressed color="indigo" dark>
            <v-icon size="20" left>mdi-file-pdf-outline</v-icon>
            Relatorio Bairros
          </v-btn>
          <v-btn v-if="routeTipo === 'usuario'" @click="openRelatorioUsuario"
                 depressed color="teal" dark>
            <v-icon size="20" left>mdi-file-pdf-outline</v-icon>
            Relatorio Usuários
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <PDF/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PDF from '@/views/public/modal/Pdf.vue';
import relatoriosHttp from '@/services/http/resources/configuracao/relatoriosHttp';

export default {
  name: 'RelatorioList',
  components: {
    PDF,
  },
  metaInfo: {
    title: 'Relatórios',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    title: 'Relatórios',
  }),
  computed: {
    routeTipo() {
      return this.$route.params.tipo;
    },
  },
  methods: {
    ...mapActions('app', ['toggleModalPdf']),
    openRelatorioBairro() {
      relatoriosHttp.bairros()
        .then(({ data }) => {
          const file = new Blob([data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          this.toggleModalPdf(fileURL);
        })
        .catch(() => {
          console.log('Error open PDF');
        });
    },
    openRelatorioUsuario() {
      relatoriosHttp.usuarios()
        .then(({ data }) => {
          const file = new Blob([data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          this.toggleModalPdf(fileURL);
        })
        .catch(() => {
          console.log('Error open PDF');
        });
    },
  },
};
</script>

<style></style>
